import React, { Component } from 'react';
import { GridRow, GridColumn } from 'react-onei';
import ErrorView from './components/Errors/ErrorView';

/**
 * ErrorBoundary component is used for intercept component error, send Sentry report and display ErrorView
 */
class ErrorBoundary extends Component {
  state = {
    debugMode: false,
    hasError: false,
  };

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  /**
   * Catch error event
   * @param   {Object} error     The error thrown by the encapsuled components
   * @param   {Object} errorInfo The error info thrown by the encapsuled components
   */
  componentDidCatch(error, errorInfo) {
    const { debugMode } = this.state;

    if (debugMode) {
      // Report to Sentry app
      // Raven.captureException(error, { extra: errorInfo });
    }
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;

    if (hasError) {
      return (
        <GridRow>
          <GridColumn>
            <ErrorView />
          </GridColumn>
        </GridRow>
      );
    }
    return children;
  }
}

ErrorBoundary.defaultProps = {
};

ErrorBoundary.propTypes = {
};

export default ErrorBoundary;
